module.exports = __webpack_public_path__ + "img/p1-1.82997fdb.png";